import {
  AddMeetingSuggestionDocument,
  MeetingCancelSignupScreenDocument,
  MeetingSignupScreenDocument,
  MeetingSubscription,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const addSuggestion = async ({
  profile,
  meetingId,
  suggestion,
}: {
  profile: ScreenProfile;
  meetingId: string;
  suggestion: string;
}) => {
  const response = await apolloClient.mutate({
    mutation: AddMeetingSuggestionDocument,
    variables: {
      profile,
      meetingId,
      suggestion,
    },
    errorPolicy: 'all',
  });

  if (response.data?.meeting?.suggestScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.meetings.addSuggestion`, response);
};

const signup = async (
  subscription: MeetingSubscription,
  profile: ScreenProfile
) => {
  const response = await apolloClient.mutate({
    mutation: MeetingSignupScreenDocument,
    variables: {
      subscription,
      profile,
    },
    errorPolicy: 'all',
  });

  if (response.data?.meeting?.signup?.success) {
    return response.data.meeting.signup;
  }

  throw new SentryGraphQLError(`api.meetings.signup`, response);
};

const cancelSignup = async (
  subscription: MeetingSubscription,
  profile: ScreenProfile
) => {
  const response = await apolloClient.mutate({
    mutation: MeetingCancelSignupScreenDocument,
    variables: {
      subscription,
      profile,
    },
    errorPolicy: 'all',
  });

  if (response.data?.meeting?.cancelSignup?.success) {
    return response.data.meeting.cancelSignup;
  }

  throw new SentryGraphQLError(`api.meetings.cancelSignup`, response);
};

export default {
  addSuggestion,
  signup,
  cancelSignup,
};
